import { apiClient } from './api';

export interface ModuleMeta {
  key: string;
  label: string;
}

export interface PermissionsMatrix {
  [role: string]: { [module_key: string]: boolean };
}

export interface FullMatrixResponse {
  modules: ModuleMeta[];
  roles: string[];
  matrix: PermissionsMatrix;
}

export interface TenantMatrixResponse extends FullMatrixResponse {
  tenant: { id: string; name: string; slug: string };
}

export interface PermissionPatch {
  role: string;
  module_key: string;
  allowed: boolean;
}

export async function getMyAccess(): Promise<Record<string, boolean>> {
  const res = await apiClient.get<{ data: Record<string, boolean> }>(
    '/api/admin/module-permissions/my-access',
  );
  return res.data.data;
}

/** Global defaults matrix (Module Permissions tab) */
export async function getFullMatrix(): Promise<FullMatrixResponse> {
  const res = await apiClient.get<{ success: boolean; data: FullMatrixResponse }>(
    '/api/admin/module-permissions',
  );
  return res.data.data;
}

/** Patch global defaults */
export async function patchPermissions(patches: PermissionPatch[]): Promise<FullMatrixResponse> {
  const res = await apiClient.patch<{ success: boolean; data: FullMatrixResponse }>(
    '/api/admin/module-permissions',
    { patches },
  );
  return res.data.data;
}

/** Effective matrix for a specific tenant (merged with global defaults) */
export async function getTenantMatrix(tenantId: string): Promise<TenantMatrixResponse> {
  const res = await apiClient.get<{ success: boolean; data: TenantMatrixResponse }>(
    `/api/admin/tenants/${tenantId}/permissions`,
  );
  return res.data.data;
}

/** Patch permissions for a specific tenant */
export async function patchTenantPermissions(tenantId: string, patches: PermissionPatch[]): Promise<TenantMatrixResponse> {
  const res = await apiClient.patch<{ success: boolean; data: TenantMatrixResponse }>(
    `/api/admin/tenants/${tenantId}/permissions`,
    { patches },
  );
  return res.data.data;
}
